<template>
  <!-- 限额分配记录 -->
  <div class="group-relationship-mana">
    <a-card style="margin-bottom: 10px">
      <search-view
        :renderItem="RELATION_SEARCH_SCHEMA"
        :isExpandShowOrNot="false"
        :initialValues="initSearchForm"
        @fetchSearch="handleSearch"
      ></search-view>
    </a-card>
    <a-card>
      <div class="right">
        <a-button @click="toApply" type="primary" style="margin:0px 20px">
          发起申请
        </a-button>
        <!-- 批量申请Modal -->
        <!-- <batch-upload-modal
          ref="batchUploadModal"
          btnText="批量申请"
          modal-title="批量申请"
          @ok="handleBatchModalOk"
          @download="_downloadBatchTemp"
        /> -->
        <!-- BatchUploadCancel -->
        <!-- 批量申请Modal -->
        <batch-upload-Cancel
          ref="batchUploadCancelModal"
          btnText="批量取消"
          modal-title="批量取消"
          @ok="handleBatchCancelModalOk"
          @download="_downloadCancelBatchTemp"
        />
        <!-- 导出 -->
        <a-button type="primary" icon="download" @click="exportFile">
          导出
        </a-button>
        <!-- 新增
        <add-ralation-modal
          @ok="handleAddRelationModalOk"
          ref="addRalationModal"
        /> -->
      </div>

      <table-view
        :data="tableData"
        :columns="columns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="SCROLL"
        @handlePagination="handlePagination"
      >
        <template v-slot:bpmId="{ tableRow }">
          <span class="name" @click="handleView(tableRow)">
            {{ tableRow.bpmId }}
          </span>
        </template>
        <template v-slot:creditAmount="{ tableRow }">
          <span>{{ tableRow.creditAmount | formatAmount }}</span>
        </template>
        <template v-slot:status="{ tableRow }">
          <a-tag
            :color="STATUS_COLOR_OBJ[tableRow.status]"
            style="width: 70px; text-align: center;"
          >
            {{ tableRow.status }}
          </a-tag>
        </template>
        <template v-slot:action="{ tableRow }">
          <a-popconfirm
            v-if="tableRow.status === 1"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleRevoke(tableRow)"
          >
            <template slot="title">
              <p>确认解绑？</p>
              <p>解绑后，子公司被分配的限额将归还母公司</p>
            </template>
            <a-icon slot="icon" type="question-circle-o" class="icon-color" />
            <a-button type="link" size="small">
              取消绑定
            </a-button>
          </a-popconfirm>
        </template>
      </table-view>
    </a-card>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
// import BatchUploadModal from 'components/BatchUploadModal.vue'
import BatchUploadCancel from 'components/BatchUploadCancel.vue'
import cloneDeep from 'lodash/cloneDeep'
import { RELATION_SEARCH_SCHEMA } from './schema'
import { STATUS_COLOR_OBJ } from './const'
import {
  getRelationList,
  cancelRelation,
  // uploadRelationBatch,
  // downloadRelationTemp,
  addRelation,
  getListCManager,
  downloadgroup,
  downloadCancelRelationTemp,
  uploadCancelRelationBatch,
} from './api'
import { ERR_OK } from 'config/index'
import moment from 'moment'

export default {
  name: 'group-relationship-mana',
  data() {
    const initSearchForm = {
      parentCode: '',
      childCode: '',
      childName: '',
      parentName: '',
      relationStatus: '',
      relationType: '',
      applier: '',
      applyStatus: '',
      creditManager: '',
    }
    const searchForm = cloneDeep(initSearchForm)
    return {
      RELATION_SEARCH_SCHEMA,
      STATUS_COLOR_OBJ,
      tableLoading: false,
      initSearchForm,
      searchForm,
      tableData: [],
      columns: [
        {
          fixed: 'left',
          title: '序号',
          width: 60,
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '母公司ID',
          dataIndex: 'parentCode',
          width: 120,
        },
        {
          title: '母公司名称',
          dataIndex: 'parentName',
          width: 120,
        },
        {
          title: '分公司ID',
          dataIndex: 'childCode',
          width: 120,
        },
        {
          title: '分公司名称',
          dataIndex: 'childName',
          width: 120,
        },
        {
          title: '关联状态',
          dataIndex: 'statusStr',
          width: 120,
        },

        {
          title: '关联类型',
          dataIndex: 'relationTypeStr',
          width: 120,
        },
        {
          title: '信用主管',
          dataIndex: 'creditManager',
          width: 120,
        },
        {
          title: '当前有效授信金额(元)',
          scopedSlots: { customRender: 'creditAmount' },
          dataIndex: 'creditAmount',
          width: 120,
        },
        {
          title: '申请单号',
          scopedSlots: { customRender: 'bpmId' },
          dataIndex: 'bpmId',
          width: 120,
        },
        {
          title: '申请人',
          dataIndex: 'applier',
          width: 120,
        },
        {
          title: '申请状态',
          dataIndex: 'bpmStautsStr',
          width: 120,
        },
        {
          title: '申请日期',
          dataIndex: 'applyDate',
          width: 120,
        },
        {
          title: '审批人',
          dataIndex: 'approver',
          width: 120,
        },
        {
          title: '审批日期',
          dataIndex: 'approveDate',
          width: 120,
        },
        {
          title: '取消关联时间',
          dataIndex: 'deleteTime',
          width: 120,
        },
        {
          title: '取消关联操作人',
          dataIndex: 'operator',
          width: 120,
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
          width: 100,
          fixed: 'right',
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      SCROLL: { x: 1150 },
    }
  },
  mounted() {
    this._getRelationList(this.initSearchForm)
    this._getListCManager()
  },
  methods: {
    handleView(data) {
      if (data.isBatch === 1) {
        this.$router.push({
          path: `/customer-credit/group-relationship-batch-detail/${data.bpmId}`,
          query: {
            status: 2,
          },
        })
      } else {
        this.$router.push({
          path: `/customer-credit/approved-approval/${data.bpmId}`,
          query: {
            companyCode: data.childCode,
            status: 2,
          },
        })
      }
    },
    // 导出
    exportFile() {
      downloadgroup(this.searchForm)
    },
    toApply() {
      this.$router.push({
        name: 'group-relationship-application',
        query: {
          code: this.companyCode,
        },
      })
    },
    //信用主管
    async _getListCManager() {
      try {
        const { data } = await getListCManager()
        this.RELATION_SEARCH_SCHEMA[8].selectList = data.map(item => {
          return {
            text: item.name + '-' + item.username,
            value: item.username,
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
    async _getRelationList(searchForm) {
      if (this.tableLoading) {
        return
      }
      this.tableLoading = true
      const { current, pageSize } = this.pageData
      const formData = {
        ...searchForm,
        size: pageSize,
        current,
      }
      try {
        const {
          data: { total, records },
        } = await getRelationList(formData)
        this.pageData.total = total
        this.tableData = records
        this.tableData.map(item => {
          if (item.applyDate) {
            item.applyDate = moment(item.applyDate).format('YYYY-MM-DD')
          }
          if (item.approveDate) {
            item.approveDate = moment(item.approveDate).format('YYYY-MM-DD')
          }
          if (item.deleteTime) {
            item.deleteTime = moment(item.deleteTime).format('YYYY-MM-DD')
          }
        })
        this.tableLoading = false
      } catch (error) {
        console.error(error)
      }
    },
    handleSearch(data) {
      this.searchForm = data
      this.pageData.current = 1 // 设置为第一页
      this._getRelationList(data)
    },
    handlePagination(pagination) {
      ;({
        current: this.pageData.current,
        pageSize: this.pageData.pageSize,
        total: this.pageData.total,
      } = pagination)
      this._getRelationList(this.searchForm)
    },
    // 取消授信
    async handleRevoke(row) {
      const id = row.id
      try {
        const { code, message } = await cancelRelation(id)
        if (code == ERR_OK) {
          this.$notification.success({
            message: '提示',
            description: message,
          })
          this._getRelationList(this.searchForm)
        } else if(code == '0001'){
          this.$notification.error({
            message: '提示',
            description: message,
          })
        }
      } catch (error) {
        console.error(error)
      }
    },
    async handleBatchCancelModalOk(fileList) {
      if (fileList && fileList.length) {
        try {
          const { code, message } = await uploadCancelRelationBatch({
            file: fileList,
          })
          if (code === ERR_OK) {
            this.$notification.success({
              message: '提示',
              description: message || '成功',
            })
            this.handleModalCancelAll()
            this._getRelationList(this.searchForm)
          } else {
            this.$notification.error({
              message: '提示',
              description: message || '失败',
            })
          }
        } catch (error) {
          console.error(error)
        }
      }
    },
    // async handleBatchModalOk(fileList) {
    //   if (fileList && fileList.length) {
    //     try {
    //       const { code, message } = await uploadRelationBatch({
    //         file: fileList,
    //       })
    //       if (code === ERR_OK) {
    //         this.$notification.success({
    //           message: '提示',
    //           description: message || '成功',
    //         })
    //         this.handleModalCancel()
    //         this._getRelationList(this.searchForm)
    //       } else {
    //         this.$notification.error({
    //           message: '提示',
    //           description: message || '失败',
    //         })
    //       }
    //     } catch (error) {
    //       console.error(error)
    //     }
    //   }
    // },
    handleModalCancelAll() {
      this.$refs.batchUploadCancelModal.handleCancel()
    },
    // handleModalCancel() {
    //   this.$refs.batchUploadModal.handleCancel()
    // },
    // 批量取消
    _downloadCancelBatchTemp() {
      downloadCancelRelationTemp()
    },
    // 批量申请
    // _downloadBatchTemp() {
    //   downloadRelationTemp()
    // },
    // 提交新增
    async handleAddRelationModalOk(params) {
      if (params) {
        try {
          await addRelation(params)
          // this.handleAddModalCancel()
          this._getRelationList(this.searchForm)
        } catch (error) {
          console.error(error)
        }
      }
    },
    // handleAddModalCancel() {
    //   this.$refs.addRalationModal.handleCancel()
    // },
  },
  components: {
    SearchView,
    TableView,
    // BatchUploadModal,
    BatchUploadCancel,
  },
}
</script>
<style scoped lang="less">
.ant-modal-content {
  width: 800px;
  margin-left: -100px;
}
.right {
  text-align: right;
  margin-bottom: 20px;
}
.name {
  color: #409eff;
  cursor: pointer;
}
</style>
